/**
 * Extrai focos de um FireScanResult.raw_detections_json.
 * Prioridade: latest → before_merge_by_source (scans legados).
 */
export function getDetectionsFromScan(scan) {
  const raw = scan?.raw_detections_json;
  if (!raw || typeof raw !== "object") return [];

  const fromList = (items) => {
    if (!Array.isArray(items)) return [];
    return items
      .filter((d) => d && d.lat != null && d.lon != null)
      .map((d) => ({
        lat: Number(d.lat),
        lon: Number(d.lon),
        acq_date: d.acq_date || null,
        acq_time: d.acq_time || null,
        satellite: d.satellite || null,
        instrument: d.instrument || null,
        confidence: d.confidence ?? null,
        frp: d.frp ?? null,
        brightness: d.brightness ?? null,
        firms_query_source: d.firms_query_source || null,
      }))
      .filter((d) => Number.isFinite(d.lat) && Number.isFinite(d.lon));
  };

  const latest = fromList(raw.latest);
  if (latest.length > 0) return latest;

  const before = raw.before_merge_by_source;
  if (!before || typeof before !== "object") return [];

  const seen = new Set();
  const out = [];
  for (const items of Object.values(before)) {
    for (const d of fromList(items)) {
      const key = `${d.lat.toFixed(5)}:${d.lon.toFixed(5)}:${d.acq_date || ""}:${d.acq_time || ""}`;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(d);
    }
  }
  return out;
}

/** Normaliza resposta de listagem (array | { results } | { data }). */
export function normalizeListResponse(raw) {
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.results)) return raw.results;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
}
